import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Globle } from 'src/assets/globle';
import { FieldsDropDownItems } from './fieldsdropdownitems.model';

@Injectable({
  providedIn: 'root'
})
export class SubservicesfieldsdropdownitemsserviceService {

  constructor(private http: HttpClient, private global: Globle) { }

  getAll(subServiceFieldId: number) {
    return this.http.get<FieldsDropDownItems[]>(this.global.APIURL +
      "subservicefieldsdropdownitems?subServiceId=" + subServiceFieldId);
  }

  CreateUpdate(subservicefields: any) {
    console.log(subservicefields)
    return this.http.post(this.global.APIURL + "subservicefieldsdropdownitems", subservicefields)
  }
}
